<template>



    <div class="row">



        <div class="col-lg-12">
            <h3 class="entry-title"> <i class="fas fa-lock"></i> EasyCheck</h3>
        </div>


        <div class="wrap">
          <h3 class="entry-title">
            Weryfikacja EasyCheck zakończona.
          </h3>


          <div v-if="isPolling" class="polling-info">

            <div class="spinner">
              <i class="fas fa-spinner fa-spin"></i>
            </div>

            <h4 class="polling-title">Pobieramy dane transakcyjne</h4>

            <p class="info-text">
              Trwa pobieranie i analiza danych z&nbsp;Twojego konta bankowego.
              Proces ten może potrwać <strong>nawet 8&nbsp;minut</strong>.
            </p>

            <p class="info-text warning">
              <i class="fas fa-exclamation-circle"></i>
              <strong>Prosimy o&nbsp;pozostanie na tej stronie</strong> &mdash;
              nie zamykaj okna przeglądarki i&nbsp;nie odświeżaj strony.
            </p>

            <p v-if="showReassurance" class="info-text reassure">
              <i class="fas fa-hourglass-half"></i>
              Nadal czekamy na dane z&nbsp;Twojego banku.
              <strong>Prosimy o&nbsp;cierpliwość</strong> &mdash; weryfikacja niebawem się zakończy.
            </p>

            <p class="elapsed">
              Czas oczekiwania: <strong>{{ elapsedFormatted }}</strong>
            </p>
          </div>


          <div class="form-group form-btn-wrap column col-10 col-mx-auto">



          </div>


        </div>
    </div>



</template>

<script>


    //import { bus } from './main';

    // sha256
    //import sha256 from 'crypto-js/sha256';


    // Polling: do ~8 minut (100 prob co 5s)
    const POLL_INTERVAL_MS = 5000;
    const POLL_MAX_TRIES = 100;
    // Po tylu sekundach pokaz lagodzacy komunikat
    const REASSURANCE_AFTER_SEC = 120;


    export default {

       name: 'EasyCheckOkView',

        data(){

            return {

              modal: null,

              details: '',

              waitCount: 0,

              isPolling: false,
              pollingStartTs: 0,
              elapsedSec: 0,
              elapsedTimer: null,
              pollTimer: null,
              abandoned: false,
              reassureLogged: false

            }
       },


       computed: {

         elapsedFormatted() {
           let s = Math.max(0, this.elapsedSec | 0),
               m = Math.floor(s / 60),
               r = s % 60;
           return (m < 10 ? '0' + m : m) + ':' + (r < 10 ? '0' + r : r);
         },

         showReassurance() {
           return this.isPolling && this.elapsedSec >= REASSURANCE_AFTER_SEC;
         }
       },


       watch: {

         showReassurance(val) {
           if (val && !this.reassureLogged) {
             this.reassureLogged = true;
             this.log('easycheck polling - reassurance shown', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
           }
         }
       },


       methods: {


            gotomain(){

                this.$router.push({path: '/'});
            },


            startElapsedTimer() {

              this.pollingStartTs = Date.now();
              this.elapsedSec = 0;

              this.elapsedTimer = setInterval(() => {
                this.elapsedSec = Math.floor((Date.now() - this.pollingStartTs) / 1000);
              }, 1000);
            },


            stopElapsedTimer() {

              if (this.elapsedTimer) {
                clearInterval(this.elapsedTimer);
                this.elapsedTimer = null;
              }
            },


            cancelPollTimer() {

              if (this.pollTimer) {
                clearTimeout(this.pollTimer);
                this.pollTimer = null;
              }
            },


            onVisibilityChange() {

              if (!this.isPolling) return;

              if (document.visibilityState === 'hidden') {
                this.abandoned = true;
                this.log('easycheck polling - tab hidden, possible abandonment', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
              else if (document.visibilityState === 'visible') {
                this.log('easycheck polling - tab visible again', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },


            onBeforeUnload() {

              if (this.isPolling) {
                this.abandoned = true;
                this.log('easycheck polling ABANDONED - page unload', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },


            onPageHide() {

              if (this.isPolling) {
                this.abandoned = true;
                this.log('easycheck polling ABANDONED - pagehide', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },



            onWaiting( endpoint='application' ) {


              var page = this.$root.mainpage,
                  step,


                poll = () => {

                  if (this.waitCount > POLL_MAX_TRIES) {

                    this.log('easycheck polling TIMEOUT', 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');

                    this.isPolling = false;
                    this.stopElapsedTimer();
                    page.isLoading = false;

                    this.$router.push({path: 'pending'});
                    return;
                  }

                  this.waitCount++;


                  this.get( '/' + endpoint )
                      .then(response => {


                        if (!!response.data) {

                          step = response.data.hasOwnProperty('step') ? response.data.step : '';


                          !step.match(/wait|kontomatik/)
                            && this.log( 'easycheck done - status polling done, go to ' + step, 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's' );

        //console.log(step);

                          switch (step) {

                            case 'kontomatik':
                            case 'wait':
                              // log progres - okresowy heart-beat z postepu pollingu
                              if (this.waitCount % 10 === 0) {
                                this.log('easycheck polling progress', 'step=' + step, 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');
                              }
                              break;


                            case 'counteroffer':

                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;


                              // flag to make sure step was completed
                              page.aisdone = true;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_success',
                                loan_amount: this.loanAmount,
                                user_email: SHA256(this.form.client_email),
                                user_phone: SHA256(this.form.client_cellphone)
                              });*/




                              this.finishDate = response.data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');



//console.log(this.finishDate);


                              this.setValues( parseInt(response.data.net_amount),  parseInt(response.data.installments_nbr), this.getConf('tenor_sign'), this.finishDate );




//console.log(this.finishDate);





                              this.$router.push({path: 'proposal'});
                              return;


                            case 'account':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              this.$router.push({path: 'account'});
                              return;



                            case 'reject':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_failed',
                                loan_amount: this.loanAmount,
                                user_email: sha256(this.form.client_email),
                                user_phone: sha256(this.form.client_phone)
                              });*/


                              this.$router.push({path: 'rej'});
                              return;


                            case 'amodit':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              let url = response.data.step_details.split('/');

                              window.location = this.getConf('amoditSignUrl') + url[ url.length - 2 ] + '%2F' + url[ url.length - 1 ];
                              return;


                            default:
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              this.$router.push({path: 'thankyou'});
                              return;
                          }


        //console.log(response.data)


                        }
                        else {
                          this.log('easycheck polling - empty body', 'tries=' + this.waitCount);
                        }


                        // dispatch another poll request
                        if (page.isLoading && this.isPolling) {
                          this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
                        }



                      })
                      .catch(error => {

                          this.log('easycheck polling - request error', 'tries=' + this.waitCount, error && error.message ? error.message : 'no-msg');

                          // wait for timeout
                          //page.isLoading = false;
                          if (this.isPolling) {
                            this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
                          }


                          // Error
                          if (error.response) {


                          } else if (error.request) {

                          } else {
                              // Something happened in setting up the request and triggered an Error
                              //console.log('Error', error.message);
                          }
                      });


                };


                // log
                this.isPolling = true;
                this.startElapsedTimer();
                this.log( 'easycheck done - status polling start', 'max_tries=' + POLL_MAX_TRIES, 'interval_ms=' + POLL_INTERVAL_MS );


                // initial polling
                this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
            }



       },



       created() {



            var page = this.$root.mainpage,
                me = this,
                uri = window.location.href.split('?'),
                lid = null;




// get status - for test of counteroffer on next screen only
//page.isLoading = true;
//me.onWaiting();
//return;




            if (uri.length > 1 && /lid=[0-9]+/.test(uri[1]) ) {


              let reg = uri[1].match(/lid=([0-9]+)/);

              lid = reg[1];
            }





//console.log('t10l created');

            me.log( 'easycheck page visible', lid ? 'lid=' + lid : 'no-lid' );




            !!lid && me.post( '/transactionlink', {
                              "loan_id": lid,
                              "t10l":  'easycheck'

            })
            .then(response => {

                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);

                  me.log('easycheck /transactionlink response', 'ok=' + ok);

                  // get status
                  page.isLoading = true;

                  me.onWaiting();

                }
              })
              .catch(error => {

                  me.log('easycheck /transactionlink error', error && error.message ? error.message : 'no-msg');

                  // Error
                  if (error.response) {

                     console.log(error.response);
                  }
              });




          // scroll to top
          this.pageTop();

       },



       mounted() {

         document.addEventListener('visibilitychange', this.onVisibilityChange, true);
         window.addEventListener('beforeunload', this.onBeforeUnload, true);
         window.addEventListener('pagehide', this.onPageHide, true);
       },



       beforeDestroy() {

         if (this.isPolling && !this.abandoned) {
           this.log('easycheck polling - view destroyed before completion', 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');
         }

         this.isPolling = false;
         this.cancelPollTimer();
         this.stopElapsedTimer();

         document.removeEventListener('visibilitychange', this.onVisibilityChange, true);
         window.removeEventListener('beforeunload', this.onBeforeUnload, true);
         window.removeEventListener('pagehide', this.onPageHide, true);
       }



    }
</script>



<style scoped>

h3 i {
    color: #0bc268;
}

.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.polling-info {
  max-width: 640px;
  margin: 1.5em auto 2.5em;
  padding: 2em 1.5em;
  background: #f7f9fc;
  border: 1px solid #e1e7ef;
  border-radius: 12px;
  text-align: center;
}

.polling-info .spinner {
  font-size: 42px;
  color: #0bc268;
  margin-bottom: .8em;
}

.polling-title {
  font-size: 22px;
  margin: 0 0 1em;
  color: #1c2330;
}

.info-text {
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 .9em;
  color: #3a4250;
}

.info-text.warning {
  color: #b35a00;
}

.info-text.warning i {
  margin-right: .35em;
}

.info-text.reassure {
  margin-top: 1.2em;
  padding: .8em 1em;
  background: #fff7e6;
  border: 1px solid #ffe2b3;
  border-radius: 8px;
  color: #7a4a00;
}

.info-text.reassure i {
  margin-right: .35em;
  color: #c97c00;
}

.elapsed {
  margin-top: 1.2em;
  font-size: 18px;
  color: #1c2330;
}

.elapsed strong {
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
}


</style>



// WEBPACK FOOTER //
// src/EasyCheckOkView.vue